export default "__VITE_ASSET__fv4PFkwB__"